import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

const CLUSTERS = [
    "facebook-ad-account-disabled-recovery",
    "high-spend-google-ads-accounts",
    "tiktok-whitelisted-accounts",
    "agency-ad-account-vs-personal",
    "agency-ad-account-pricing-guide",
    "whitelisted-ad-accounts",
    "daily-spend-limit-solution",
];

const TITLES = {
    "facebook-ad-account-disabled-recovery": {
        en: "Facebook ad account disabled recovery",
        pt: "Recuperação de conta Facebook desativada",
        es: "Recuperación de cuenta Facebook deshabilitada",
        ru: "Восстановление отключенного Facebook аккаунта",
        tr: "Facebook hesabı kapanma sonrası operasyon",
    },
    "high-spend-google-ads-accounts": {
        en: "High spend Google Ads accounts",
        pt: "Contas Google Ads para alto investimento",
        es: "Cuentas Google Ads para alto gasto",
        ru: "Google Ads аккаунты для больших бюджетов",
        tr: "Yüksek harcama için Google Ads hesapları",
    },
    "tiktok-whitelisted-accounts": {
        en: "TikTok whitelisted accounts",
        pt: "Contas TikTok whitelisted",
        es: "Cuentas TikTok whitelisted",
        ru: "Whitelisted аккаунты TikTok",
        tr: "TikTok whitelisted hesaplar",
    },
    "agency-ad-account-vs-personal": {
        en: "Agency ad account vs personal",
        pt: "Conta de agência vs pessoal",
        es: "Cuenta de agencia vs personal",
        ru: "Агентский аккаунт vs персональный",
        tr: "Ajans hesabı vs bireysel hesap",
    },
    "agency-ad-account-pricing-guide": {
        en: "Agency ad account pricing guide",
        pt: "Guia de preços de conta de agência",
        es: "Guía de precios de cuenta de agencia",
        ru: "Гайд по ценам агентских аккаунтов",
        tr: "Ajans reklam hesabı fiyat rehberi",
    },
    "whitelisted-ad-accounts": {
        en: "Whitelisted ad accounts",
        pt: "Contas whitelisted",
        es: "Cuentas whitelisted",
        ru: "Whitelisted аккаунты",
        tr: "Whitelisted reklam hesapları",
    },
    "daily-spend-limit-solution": {
        en: "Daily spend limit solution",
        pt: "Solução para limite diário",
        es: "Solución para límite diario",
        ru: "Решение daily spend limit",
        tr: "Günlük harcama limiti çözümü",
    },
};

export default function SeoClusterSection() {
    const { language } = useLanguage();
    const c = {
        en: {
            eyebrow: "Search Guides",
            title: "Explore high-intent ad operations guides",
            subtitle:
                "Built to answer real operator queries around account continuity, scaling, and pricing logic.",
        },
        pt: {
            eyebrow: "Guias de busca",
            title: "Explore guias de alta intenção",
            subtitle:
                "Criados para responder dúvidas reais sobre continuidade, escala e precificação.",
        },
        es: {
            eyebrow: "Guías de búsqueda",
            title: "Explora guías de alta intención",
            subtitle:
                "Diseñadas para responder dudas reales sobre continuidad, escala y pricing.",
        },
        ru: {
            eyebrow: "Поисковые гайды",
            title: "Гайды с высоким intent",
            subtitle:
                "Отвечают на реальные запросы про непрерывность, масштаб и pricing-логику.",
        },
        tr: {
            eyebrow: "Arama Rehberleri",
            title: "Yüksek niyetli operasyon rehberleri",
            subtitle:
                "Hesap sürekliliği, ölçekleme ve fiyat mantığıyla ilgili gerçek operatör sorgularına odaklanır.",
        },
    }[language] || {
        eyebrow: "Search Guides",
        title: "Explore high-intent ad operations guides",
        subtitle:
            "Built to answer real operator queries around account continuity, scaling, and pricing logic.",
    };

    return (
        <section
            data-testid="seo-cluster-section"
            className="py-16 border-y border-white/[0.06] bg-white/[0.01]"
        >
            <div className="container-skala">
                <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-primary mb-2">
                    {c.eyebrow}
                </p>
                <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
                    {c.title}
                </h2>
                <p className="text-sm text-muted-foreground mt-3 max-w-3xl">{c.subtitle}</p>

                <div className="flex flex-wrap gap-2 mt-6">
                    {CLUSTERS.map((slug) => (
                        <Link
                            key={slug}
                            to={`/solutions/${slug}`}
                            data-testid={`seo-cluster-link-${slug}`}
                            className="text-xs md:text-sm px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02] hover:border-primary/40 hover:text-primary transition-colors"
                        >
                            {(TITLES[slug]?.[language] || TITLES[slug]?.en || slug).toString()}
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
